module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "citation"
  }, [_c('div', {
    staticClass: "citecontent"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "citeselector"
  }, [_c('form', [_vm._v("\nChoose Style: \n"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.style),
      expression: "style"
    }],
    staticClass: "citeselect",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.style = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n    " + _vm._s(option.text) + "\n  ")])
  })), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.text),
      expression: "text",
      arg: "copy"
    }]
  }, [_vm._v("\nCopy Citation\n")])])]), _vm._v(" "), _c('p')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63364bad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pubs/newcitation.vue
// module id = 197
// module chunks = 0